module.exports = __webpack_public_path__ + "img/yankees.67b531ea.svg";